import {addDays} from 'date-fns'

import {parseApiDate, toApiDateString} from 'src/jobs/job-schedule-format'

export function datesForTbcJob(
    startDate: string,
    dayCount: number | null | undefined,
): {startDate: string; endDate: string | null} {
    if (dayCount == null) {
        return {startDate, endDate: null}
    }

    const lastDay = addDays(parseApiDate(startDate), Math.max(1, dayCount) - 1)
    return {startDate, endDate: toApiDateString(lastDay)}
}
